import Skeleton from "@mui/material/Skeleton";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";

export default function LazyCDNImage(
  {
    isBackground = false, // img or background img
    onVisible, // 화면에 이 컴포넌트가 들어왔을 때 처리하는 콜백 함수
    className,
    children,
    aiSeq = false,
    cdnUrl,
    style,
    ...rest
  },
  props
) {
  const [observer, setObserver] = useState(null);
  const [source, setSource] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const loadEl = useRef(null);
  const option = {
    root: null,
    threshold: 0, // 화면에 몇퍼센트 노출되야 이미지가 보여질지 설정
  };

  const handleObserver = (entries) => {
    const target = entries[0];
    if (target.isIntersecting) {
      if (onVisible) onVisible();
      const img = new Image();
      img.src = imageUrl;
      img.onload = () => {
        if (isBackground) {
          setSource(`url(${imageUrl})`);
        } else {
          setSource(imageUrl);
        }
      };
    }
  };

  const loadCDNImageData = () => {
    return new Promise((resolve) => {
      axios.get(`/api/st/attach-image/get-path/` + aiSeq).then((res) => {
        resolve(res.data.data.imgPath);
      });
    });
  };

  useEffect(async () => {
    let imageUrl = cdnUrl;
    if (aiSeq) imageUrl = await loadCDNImageData();
    else imageUrl = cdnUrl;

    setImageUrl(imageUrl);

    return () => {
      if (observer) {
        observer.disconnect();
        setObserver(null);
        setImageUrl(null);
      }
    };
  }, []);

  useEffect(() => {
    if (imageUrl) {
      const observer = new IntersectionObserver(handleObserver, option);
      setObserver(observer);
      if (loadEl.current) observer.observe(loadEl.current);
    }
  }, [imageUrl]);

  return (
    <>
      {source ? (
        <>
          {isBackground === true ? (
            <div
              {...rest}
              className={className}
              style={{
                backgroundImage: source,
                backgroundSize: "contain",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundColor: "#eee",
                ...style,
              }}
            >
              {children}
            </div>
          ) : (
            <img
              {...rest}
              className={className}
              style={{
                ...style,
              }}
              src={source}
            >
              {children}
            </img>
          )}
        </>
      ) : (
        <Skeleton
          ref={loadEl}
          className={"image-loader"}
          style={{
            width: "100%",
            height: "100%",
            transform: "scale(1)",
            ...style,
          }}
        />
      )}
    </>
  );
}
